'use client';

import { forwardRef, TextareaHTMLAttributes } from 'react';

interface TextareaFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

const TextareaField = forwardRef<HTMLTextAreaElement, TextareaFieldProps>(
  ({ hasError, className = '', ...props }, ref) => {
    return (
      <textarea data-component-id="src/app/provider-profile-form/components/TextareaField.tsx:12:6" data-component-path="src/app/provider-profile-form/components/TextareaField.tsx" data-component-line="12" data-component-end-line="26" data-component-file="TextareaField.tsx" data-component-name="textarea" data-component-content="%7B%22elementName%22%3A%22textarea%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        ref={ref}
        className={`
          w-full px-3 py-2.5 rounded-lg border text-sm font-medium text-foreground bg-white
          placeholder:text-muted-foreground placeholder:font-normal
          transition-all duration-150 resize-y min-h-[80px]
          focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary
          disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-muted
          ${hasError
            ? 'border-destructive focus:ring-destructive/20 focus:border-destructive bg-destructive/5' :'border-input hover:border-primary/50'
          }
          ${className}
        `}
        {...props}
      />
    );
  }
);

TextareaField.displayName = 'TextareaField';
export default TextareaField;